export var REDUX_FORM_NAME = 'record-form';
